import React, { useEffect, useRef } from 'react';
import HotelIconMarker from '@this/shared/hotel_map/hotel_icon_marker';
import DestMarker from '@this/shared/hotel_map/dest_marker';

interface Props {
  hotelLocation: { lat: number; lng: number };
  destLocation?: { lat: number; lng: number } | null;
  height?: number;
  serviceId?: number;
}

const HotelLocationMap = ({ hotelLocation, destLocation, height = 180, serviceId = 1 }: Props) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<google.maps.Map | null>(null);
  const hotelMarkerRef = useRef<HotelIconMarker | null>(null);
  const destMarkerRef = useRef<DestMarker | null>(null);

  useEffect(() => {
    if (!mapRef.current || typeof google === 'undefined') return;

    const map = new google.maps.Map(mapRef.current, {
      zoom: 15,
      center: hotelLocation,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: false
    });
    mapInstanceRef.current = map;

    hotelMarkerRef.current = new HotelIconMarker(hotelLocation);
    hotelMarkerRef.current.setMap(map);

    if (destLocation) {
      destMarkerRef.current = new DestMarker(destLocation, serviceId);
      destMarkerRef.current.setMap(map);

      const bounds = new google.maps.LatLngBounds();
      bounds.extend(hotelLocation);
      bounds.extend(destLocation);
      map.fitBounds(bounds);
    }

    return () => {
      if (hotelMarkerRef.current) {
        hotelMarkerRef.current.setMap(null);
      }
      if (destMarkerRef.current) {
        destMarkerRef.current.setMap(null);
      }
    };
  }, [hotelLocation, destLocation, serviceId]);

  const styles = getStyles(height);

  return <div ref={mapRef} style={styles.mapContainer} />;
};

const getStyles = (height: number) => ({
  mapContainer: {
    width: '100%',
    height: `${height}px`,
    borderRadius: '8px',
    marginBottom: '12px'
  }
});

export default HotelLocationMap;
